module.exports = __webpack_public_path__ + "static/media/thisBanner.f14f2397.jpeg";